import railway from './railway'
import sector from './sector'
import station from './station'
import platform from './platform'
import bridge from './bridge'
import shed from './shed'
import fencing from './fencing'
import pillar from './pillar'
import mainWire from './mainWire'
import contactWire from './contactWire'



export default [
    ...railway,
    ...sector,
    ...station,
    ...platform,
    ...bridge,
    ...shed,
    ...fencing,
    ...pillar,
    ...mainWire,
    ...contactWire
]
